import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CircularProgress } from "../../components/custom";
import { useEffect, useState } from "react";
import { fetchUser } from "../../redux/slices/users";
import styled from "styled-components";
import { UserService } from "../../services/userService";
import { useAppContext } from "../../contexts/Context";
import {
  GetTeacherClass,
  GetStudentClass,
} from "../../components/custom/teacherClass";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { PATH_DASHBOARD } from "../../routes/paths";
import toast from "react-hot-toast";

export const StudentInfo = () => {
  const [isLoading, setIsLoading] = useState(true);

  const { identity } = useParams();
  const dispatch = useDispatch();
  const { user, isLoading: userLoading } = useSelector((state) => state.users || {});
  const { studentClass, setStudentClass } = useAppContext();

  useEffect(() => {
    if (!user || user._id !== identity) {
      dispatch(fetchUser({ id: identity }));
    }
  }, [identity, dispatch, user]);

  useEffect(() => {
    if (user && !userLoading) {
      GetStudentClass(user, setStudentClass);
      setIsLoading(false);
    }
  }, [user, userLoading, setStudentClass]);

  //to deactiveate users
  const deactivateUser = async (studentId, currentStatus) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      formData.append("values", JSON.stringify({ status: newStatus }));
      await UserService.updateUser(studentId, formData);
      dispatch(fetchUser({ id: identity }));
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {(isLoading || !user) && <CircularProgress />}
      <StudentWrapper className="div d-flex flex-column pt-0 pb-5 px-0">
        <div className="back-div w-100 p-0"></div>
        <div className="body container">
          <div className="headers d-flex flex-row justify-content-between align-items-center">
            <div className="profile d-flex flex-column">
              <div className="profile-image "></div>
              <h6 className="text-capitalize ">
                {user?.firstName} {user?.middleName} {user?.lastName}
              </h6>
            </div>
            <div className="buttons d-flex flex-row gap-2">
              <button className="transfer-btn">Transfer</button>
              <button
                className={
                  user?.status === "active" ? "deactivate-btn" : "activate-btn"
                }
                onClick={() => {
                  deactivateUser(user._id, user?.status);
                }}
              >
                {user?.status === "active" ? "Deactivate" : "Activate"}
              </button>
            </div>
          </div>
          <div className="content">
            <div className=" d-flex flex-column mt-4">
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize">first name:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.firstName}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">middle name:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.middleName}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">last name:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.lastName}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">admission number:</p>{" "}
                <h6 className="text-capitalize w-50">
                  {user?.admissionNumber}
                </h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">current class:</p>{" "}
                <h6 className="text-capitalize w-50">{studentClass}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">gender:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.gender}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">department :</p>{" "}
                <h6 className="text-capitalize w-50">{user?.department}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">email :</p>{" "}
                <h6 className="w-50">
                  {" "}
                  {user?.email.length > 15
                    ? `${user?.email.slice(0, 15)}...`
                    : user?.email}
                </h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">parent phone :</p>{" "}
                <h6 className="text-capitalize w-50">{user?.parentPhone}</h6>
              </div>
            </div>
          </div>
        </div>

        {/* <h4>STUDENT INFO</h4> */}
      </StudentWrapper>
    </div>
  );
};
export const TeacherInfo = () => {
  const { identity } = useParams();
  const [currentTeacher, setCurrentTeacher] = useState("");
  const { teacherClass, setTeacherClass } = useAppContext();
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { user, isLoading: userLoading } = useSelector((state) => state.users || {});

  useEffect(() => {
    if (!user || user._id !== identity) {
      dispatch(fetchUser({ id: identity }));
    }
  }, [identity, dispatch, user]);

  useEffect(() => {
    if (user && !userLoading) {
      setCurrentTeacher(user);
      GetTeacherClass(user, setTeacherClass);
      setLoading(false);
    }
  }, [user, userLoading, setTeacherClass]);
  return (
    <div>
      {(loading || !user) && <CircularProgress />}
      <TeacherWrapper className="div d-flex flex-column pt-0 pb-5 px-0">
        <div className="back-div w-100 p-0"></div>
        <div className="body container">
          <div className="headers d-flex flex-row justify-content-between align-items-center">
            <div className="profile d-flex flex-column">
              <div className="profile-image "></div>
              <h6 className="text-capitalize ">
                {user?.firstName} {user?.middleName} {user?.lastName}
              </h6>
            </div>
            <div className="buttons d-flex flex-row gap-2">
              <button className="deactivate-btn">Delete</button>
            </div>
          </div>
          <div className="content">
            <div className=" d-flex flex-column mt-4">
              <div className="info d-flex align-items-center ">
                <p className="text-uppercase w-50">Role:</p>{" "}
                <h6 className="text-uppercase w-50">{user?.role}</h6>
              </div>
              <div className="info d-flex align-items-center ">
                <p className="text-capitalize w-50">First name:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.firstName}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50">Middle name:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.middleName}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50">Last name:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.lastName}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50">Teacher id:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.teacherId}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50">Class handled:</p>{" "}
                <h6 className="text-capitalize w-50">{teacherClass}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50">Gender:</p>{" "}
                <h6 className="text-capitalize w-50">{user?.gender}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="w-50">Subject(s) taught :</p>{" "}
                <h6 className="text-capitalize w-50">{user?.subjectTaught}</h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50">Email :</p>{" "}
                <h6 className="">
                  {" "}
                  {user?.email.length > 15
                    ? `${user?.email.slice(0, 15)}...`
                    : user?.email}
                </h6>
              </div>
              <div className="info d-flex align-items-center">
                <p className="text-capitalize w-50"> Phone :</p>{" "}
                <h6 className="text-capitalize w-50">{user?.tel}</h6>
              </div>
            </div>
          </div>
        </div>
      </TeacherWrapper>
    </div>
  );
};

export const ParentInfo = () => {
  const { identity } = useParams();
  const [parent, setParent] = useState(null);
  const [wards, setWards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [wardsLoading, setWardsLoading] = useState(false);
  const [newWardAdmission, setNewWardAdmission] = useState("");
  const [addingWard, setAddingWard] = useState(false);

  useEffect(() => {
    const fetchParent = async () => {
      try {
        const response = await UserService.getUser(identity);
        setParent(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching parent:", error);
        setIsLoading(false);
      }
    };
    fetchParent();
  }, [identity]);

  useEffect(() => {
    const fetchWards = async () => {
      if (parent?.wards && parent.wards.length > 0) {
        setWardsLoading(true);
        try {
          const wardPromises = parent.wards.map((admissionNumber) =>
            UserService.findUsers({ admissionNumber, role: "student" })
          );
          const wardResponses = await Promise.all(wardPromises);
          console.log("Ward responses:", wardResponses);
          const wardsData = wardResponses
            .map((res) => res.data?.list?.[0])
            .filter(Boolean);
          setWards(wardsData);
        } catch (error) {
          console.error("Error fetching wards:", error);
        }
        setWardsLoading(false);
      }
    };
    if (parent) {
      fetchWards();
    }
  }, [parent]);

  const deactivateUser = async (parentId, currentStatus) => {
    try {
      setIsLoading(true);
      const formData = new FormData();
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      formData.append("values", JSON.stringify({ status: newStatus }));
      await UserService.updateUser(parentId, formData);
      const response = await UserService.getUser(identity);
      setParent(response.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  const handleAddWard = async (e) => {
    e.preventDefault();
    if (!newWardAdmission.trim()) {
      toast.error("Please enter an admission number");
      return;
    }
    
    const admissionNumber = newWardAdmission.trim().toUpperCase();
    setAddingWard(true);
    
    try {
      const wardCheck = await UserService.findUsers({ 
        admissionNumber: admissionNumber, 
        role: "student" 
      });
      
      console.log("Ward check response:", wardCheck);
      console.log("Ward check data:", wardCheck?.data);
      console.log("Ward list:", wardCheck?.data?.list);
      
      const wardData = wardCheck?.data?.list?.[0];
      
      if (!wardData) {
        toast.error(`No student found with admission number: ${admissionNumber}`);
        setAddingWard(false);
        return;
      }

      console.log("Found ward:", wardData);

      const existingWards = parent.wards || [];
      if (existingWards.some(w => w.toUpperCase() === admissionNumber)) {
        toast.error("This ward is already linked to this parent");
        setAddingWard(false);
        return;
      }

      const updatedWards = [...existingWards, admissionNumber];
      const formData = new FormData();
      formData.append("values", JSON.stringify({ wards: updatedWards }));
      
      await UserService.updateUser(parent._id, formData);
      
      const response = await UserService.getUser(identity);
      setParent(response.data);
      setNewWardAdmission("");
      toast.success(`Ward (${wardData.firstName} ${wardData.lastName}) added successfully!`);
    } catch (error) {
      console.error("Error adding ward:", error);
      toast.error(error?.response?.data?.message || "Failed to add ward. Please try again.");
    }
    setAddingWard(false);
  };

  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <div>
      <ParentWrapper className="div d-flex flex-column pt-0 pb-5 px-0">
        <div className="back-div w-100 p-0"></div>
        <div className="body container">
          <div className="headers d-flex flex-row justify-content-between align-items-center">
            <div className="profile d-flex flex-column">
              <div className="profile-image "></div>
              <h6 className="text-capitalize ">
                {parent?.firstName} {parent?.middleName} {parent?.lastName}
              </h6>
              <span className="badge bg-primary">{parent?.role}</span>
            </div>
            <div className="buttons d-flex flex-row gap-2">
              <Link
                to={`${PATH_DASHBOARD.admin.editParent}/${parent?._id}`}
                className="edit-btn"
              >
                Edit
              </Link>
              <button
                className={
                  parent?.status === "active" ? "deactivate-btn" : "activate-btn"
                }
                onClick={() => {
                  deactivateUser(parent._id, parent?.status);
                }}
              >
                {parent?.status === "active" ? "Deactivate" : "Activate"}
              </button>
            </div>
          </div>
          <div className="content">
            <div className=" d-flex flex-column mt-4">
              <h5 className="mb-3">Parent Details</h5>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">first name:</p>{" "}
                <h6 className="text-capitalize w-50">{parent?.firstName}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">middle name:</p>{" "}
                <h6 className="text-capitalize w-50">{parent?.middleName || "-"}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">last name:</p>{" "}
                <h6 className="text-capitalize w-50">{parent?.lastName}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">parent ID:</p>{" "}
                <h6 className="text-capitalize w-50">{parent?.parentId}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">gender:</p>{" "}
                <h6 className="text-capitalize w-50">{parent?.gender}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">email:</p>{" "}
                <h6 className="w-50">{parent?.email}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">phone:</p>{" "}
                <h6 className="text-capitalize w-50">{parent?.tel}</h6>
              </div>
              <div className="info d-flex justify-content-between">
                <p className="text-capitalize w-50">status:</p>{" "}
                <h6 className="text-capitalize w-50">
                  <span
                    className={`badge ${
                      parent?.status === "active" ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {parent?.status}
                  </span>
                </h6>
              </div>
            </div>
          </div>

          <div className="wards-section mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5>Wards ({wards.length})</h5>
              {wardsLoading && <CircularProgress size={20} />}
            </div>
            <div className="add-ward-form mb-4">
              <form onSubmit={handleAddWard} className="d-flex gap-2 align-items-center">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter admission number"
                  value={newWardAdmission}
                  onChange={(e) => setNewWardAdmission(e.target.value)}
                  style={{ maxWidth: "250px" }}
                />
                <button 
                  type="submit" 
                  className="btn btn-primary btn-sm"
                  disabled={addingWard || !newWardAdmission.trim()}
                >
                  {addingWard ? "Adding..." : "Add Ward"}
                </button>
              </form>
            </div>
            {wards.length > 0 ? (
              <Table responsive striped bordered hover>
                <thead>
                  <tr>
                    <th>Admission No.</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Class</th>
                    <th>Gender</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {wards.map((ward) => (
                    <tr key={ward._id}>
                      <td>{ward.admissionNumber}</td>
                      <td className="text-capitalize">{ward.firstName}</td>
                      <td className="text-capitalize">{ward.lastName}</td>
                      <td className="text-capitalize">{ward.currentClass}</td>
                      <td className="text-capitalize">{ward.gender}</td>
                      <td>
                        <span
                          className={`badge ${
                            ward.status === "active" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {ward.status}
                        </span>
                      </td>
                      <td>
                        <Link
                          to={`${PATH_DASHBOARD.admin.studentInfo}/${ward._id}`}
                          className="btn btn-sm btn-primary"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              !wardsLoading && (
                <p className="text-muted">No wards associated with this parent</p>
              )
            )}
          </div>
        </div>
      </ParentWrapper>
    </div>
  );
};

const StudentWrapper = styled.div`
  .back-div {
    height: 200px;
    z-index: 9;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.7),
        rgba(0, 0, 0, 0.1)
      ),
      url("https://res.cloudinary.com/duvwweuhj/image/upload/v1700698715/Firdaus/IMG-20230901-WA0004_1_pc92lu.jpg") !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
  .profile-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: red;
    z-index: 999 !important;
    margin-top: -20px;
    border: 5px solid white;
  }
  .headers {
    .transfer-btn {
      border-radius: 10px;
      border: 1px solid blue;
      color: blue;
      &:hover {
        border: 1px solid blue;
        color: white;
        background-color: blue;
      }
    }
    .deactivate-btn {
      border-radius: 10px;
      border: 1px solid black;
      color: black;
      &:hover {
        border: 1px solid black;
        color: white;
        background-color: black;
      }
    }
    .activate-btn {
      border-radius: 10px;
      border: 1px solid green;
      color: green;
      &:hover {
        border: 1px solid green;
        color: white;
        background-color: green;
      }
    }
    button {
      height: fit-content;
      padding: 3px 10px;
      font-size: 13px;
    }
  }
  .content {
  }
  @media (max-width: 1100px) {
  }
  @media screen and (max-width: 570px) {
    width: 100% !important;
  }
`;

const TeacherWrapper = styled.div`
  .back-div {
    height: 200px;
    z-index: 9;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.7),
        rgba(0, 0, 0, 0.1)
      ),
      url("https://res.cloudinary.com/duvwweuhj/image/upload/v1700698715/Firdaus/IMG-20230901-WA0004_1_pc92lu.jpg") !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
  .profile-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: red;
    z-index: 999 !important;
    margin-top: -20px;
    border: 5px solid white;
  }
  .headers {
    .transfer-btn {
      border-radius: 10px;
      border: 1px solid blue;
      color: blue;
    }
    .deactivate-btn {
      border-radius: 10px;
      border: 1px solid black;
      color: black;
    }
    button {
      height: fit-content;
      padding: 3px 10px;
      font-size: 13px;
    }
  }

  @media screen and (max-width: 570px) {
    width: 100% !important;
  }
`;

const ParentWrapper = styled.div`
  .back-div {
    height: 200px;
    z-index: 9;
    background: linear-gradient(
        to right,
        rgba(0, 0, 0, 0.7),
        rgba(0, 0, 0, 0.1)
      ),
      url("https://res.cloudinary.com/duvwweuhj/image/upload/v1700698715/Firdaus/IMG-20230901-WA0004_1_pc92lu.jpg") !important;
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }
  .profile-image {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background-color: #6c5ce7;
    z-index: 999 !important;
    margin-top: -20px;
    border: 5px solid white;
  }
  .headers {
    .edit-btn {
      border-radius: 10px;
      border: 1px solid blue;
      color: blue;
      padding: 3px 10px;
      text-decoration: none;
      font-size: 13px;
      &:hover {
        border: 1px solid blue;
        color: white;
        background-color: blue;
      }
    }
    .deactivate-btn {
      border-radius: 10px;
      border: 1px solid red;
      color: red;
      &:hover {
        border: 1px solid red;
        color: white;
        background-color: red;
      }
    }
    .activate-btn {
      border-radius: 10px;
      border: 1px solid green;
      color: green;
      &:hover {
        border: 1px solid green;
        color: white;
        background-color: green;
      }
    }
    button {
      height: fit-content;
      padding: 3px 10px;
      font-size: 13px;
    }
  }
  .info {
    border-bottom: 1px solid #eee;
    padding: 8px 0;
    p {
      color: #666;
      margin-bottom: 0;
    }
    h6 {
      font-weight: 500;
    }
  }
  .wards-section {
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  }
  .add-ward-form {
    input {
      border-radius: 5px;
      padding: 8px 12px;
      border: 1px solid #ddd;
      &:focus {
        outline: none;
        border-color: #007bff;
      }
    }
    button {
      border-radius: 5px;
    }
  }
  @media screen and (max-width: 570px) {
    width: 100% !important;
  }
`;
